import * as angular from "angular";
import { Team } from "../../models/team.model";
import { DialogUtils } from "../../helper/dialog.helper";

let AddToTeamComponent = {
    selector: "vcAddToTeam",
    templateUrl: "/angular/components/team/add-to-team.component.html",
    bindings: {},
    controller: class AddToTeamController {
        public team: Team;
        public newTeam: Team;

        private readonly $scope: any;
        private readonly dialog: DialogUtils;

        constructor($scope: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.$scope.$watch(
                () => this.newTeam,
                () => {
                    if (this.newTeam) {
                        this.dialog.hide(this.newTeam);
                    }
                },
                true
            );
        }

        confirm(team: Team): void {
            this.dialog.hide(team);
        }

        openTeamModal(ev: any): void {
            this.dialog
                .show({
                    component: "vc-team-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Create Team",
                    size: "large-plus",
                    locals: {
                        selectedTeam: {},
                        hideUsers: true,
                    },
                })
                .then((team: Team) => this.dialog.hide(team));
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("team", [])
    .component(AddToTeamComponent.selector, AddToTeamComponent);
